import { useCallback } from "react";
import { ProductsApi, useAPIAction } from "melco-shared-logic";

export const useProReportingJoinBetaTesting = () => {
  const [ProReportingJoinBetaTesting] = useAPIAction(
    ProductsApi,
    async (api: ProductsApi) => {
      let data = await api.productsStartBeta();

      return {
        data,
        successMessages: [{ message: "default" }],
      };
    },
    {
      translationPrefix: "reporting.proreporting.actions.joinbeta",
    }
  );

  return useCallback(async () => {
    return await ProReportingJoinBetaTesting();
  }, [ProReportingJoinBetaTesting]);
};
